module.exports = __webpack_public_path__ + "img/code-app.c0f92d82.svg";